var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1000002454(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0556641,
    y: 0.317383,
    width: 41.9141,
    height: 41.9141,
    rx: 6.44833,
    fill: "#D7D7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0523 17.364H16.2509V14.3718C16.2509 12.7247 17.5898 11.3858 19.237 11.3858H22.7925C24.4396 11.3858 25.7785 12.7247 25.7785 14.3718C25.7785 14.9352 26.2357 15.3924 26.7991 15.3924C27.3624 15.3924 27.8196 14.9352 27.8196 14.3718C27.8196 11.6001 25.5642 9.34473 22.7925 9.34473H19.237C16.4652 9.34677 14.2098 11.6021 14.2098 14.3739V17.3661H13.9751C12.6995 17.3661 11.6626 18.4009 11.6626 19.6786V31.2942C11.6626 32.5699 12.6974 33.6068 13.9751 33.6068H28.0523C29.3279 33.6068 30.3648 32.5719 30.3648 31.2942V19.6786C30.3648 18.4029 29.33 17.3661 28.0523 17.3661V17.364ZM22.1475 27.7061L22.4088 30.1594H19.6186L19.8799 27.7061C19.2492 27.3224 18.8247 26.6304 18.8247 25.8365C18.8247 24.6282 19.8044 23.6485 21.0127 23.6485C22.221 23.6485 23.2007 24.6282 23.2007 25.8365C23.2007 26.6304 22.7782 27.3224 22.1455 27.7061H22.1475Z",
    fill: "url(#paint0_linear_1352_1057)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1352_1057",
    x1: 25.5216,
    y1: 9.34473,
    x2: 21.3351,
    y2: 37.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70E9A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1398DD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000002454);
export default __webpack_public_path__ + "static/media/Group-1000002454.d40e8e44fa20e4f36fc1b87cf38b5c57.svg";
export { ForwardRef as ReactComponent };